const TriggerGameBoxTransferReducers = (state = false, action) => {
  switch (action.type) {
    case "triggerGameBoxTransfer":
      return (state = true);
    case "closeGameBoxTransfer":
      return (state = false);
    default:
      return state;
  }
};
export default TriggerGameBoxTransferReducers;
